import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
import { getAuth, createUserWithEmailAndPassword, GoogleAuthProvider, User as fUser } from "firebase/auth";

var firebaseConfig = {
    apiKey: "AIzaSyAnnLUtbe_u0ATD6jwjUN-Ok7cjnBwXwWw",
    authDomain: "remerge-se.firebaseapp.com",
    databaseURL: "https://remerge-se.firebaseio.com",
    projectId: "remerge-se",
    storageBucket: "remerge-se.appspot.com",
    messagingSenderId: "116705960161",
    appId: "1:116705960161:web:44ba784a873b75fc"
};

// dev

/*
firebaseConfig = {
    apiKey: "AIzaSyAOwXNrdmULOozVG2TnFep-vyzGAka-zbc",
    authDomain: "remerge-se-development.firebaseapp.com",
    projectId: "remerge-se-development",
    storageBucket: "remerge-se-development.appspot.com",
    messagingSenderId: "384279072907",
    appId: "1:384279072907:web:b8c7057da2630bfbb5848e",
    databaseURL: "https://remerge-se.firebaseio.com",
  };
    */


const app = initializeApp(firebaseConfig);

export type User = fUser;
export const auth = getAuth();
export const googleAuthProviderID = GoogleAuthProvider.PROVIDER_ID;
export const firestore = getFirestore(app);
